import { render, staticRenderFns } from "./DateTimePicker.vue?vue&type=template&id=143bdb12&"
import script from "./DateTimePicker.vue?vue&type=script&lang=js&"
export * from "./DateTimePicker.vue?vue&type=script&lang=js&"
import style0 from "./DateTimePicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDate,QBtn,QTime,QList} from 'quasar'
component.options.components = Object.assign({QDate,QBtn,QTime,QList}, component.options.components || {})
